import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig';
import { authenticatePublishingWallet } from './digitalAssetsClient';

const manage = httpsCallable(functions, 'managePublishingCredentials', { timeout: 60000 });
export async function managePublishingCredentials(wallet, action, payload = {}, { isCurrent = () => true } = {}) {
    const publicKey = await authenticatePublishingWallet(wallet, { isCurrent, forceSignature: action === 'replace' });
    if (!isCurrent()) throw new Error('Wallet changed. Please retry.');
    return (await manage({ ...payload, action, publicKey })).data;
}
